import { userConstants } from "../../constant";

export function chat(state = [], action) {
  switch (action.type) {
    case userConstants.LIST_OF_MY_CHATS:
      return {
        chats: action.users,
      };

    default:
      return state;
  }
}
